import TicketDao from "./TicketDao";
import { TicketControl, TerminalType } from "../model";
import { TicketApi } from "../swagger";

export class SwaggerTicketDao implements TicketDao {
  private readonly _ticketControlSwaggerClient: TicketApi;

  public constructor(ticketControlSwaggerClient: TicketApi) {
    this._ticketControlSwaggerClient = ticketControlSwaggerClient;
  }

  public async getTicketControlByLicensePlate(
    cityId: string,
    licensePlate: string,
    params?: {
      accuracy?: number;
      latitude?: number;
      longitude?: number;
      scandate?: string;
      terminalType?: TerminalType;
      matricule?: string;
      requestSrc?: string;
    }
  ): Promise<TicketControl> {
    const res = await this._ticketControlSwaggerClient.getTicketControl(
      cityId,
      licensePlate,
      params?.latitude,
      params?.longitude,
      params?.accuracy,
      params?.scandate,
      params?.terminalType,
      params?.matricule,
      params?.requestSrc
    );

    res.data.status = res.data.status?.toUpperCase() as any; // @hotfix

    return res.data;
  }
}

export default SwaggerTicketDao;
